import React from "react";
import { Link } from "react-router-dom";

const services = [
  {
    title: "Comprehensive & Routine Eye Checkup",
    summary:
      "Eye check-up is an evaluation of the vision of your eyes and it is checked that you have any eye-related disease or not.",
    img: "https://prasad-eye-hospital-public.s3.ap-south-1.amazonaws.com/images/services/squint.png",
    imgAlt: "squint",
  },
  {
    title: "Cataract",
    summary:
      "A cataract is clouding or opacity of the lens inside the eye. It causes gradual blurring of vision and finally blindness.",
    img: "https://prasad-eye-hospital-public.s3.ap-south-1.amazonaws.com/images/services/cataract.png",
    imgAlt: "cataract",
  },
  {
    title: "Glaucoma",
    summary:
      "Glaucoma is a term given to a group of eye conditions in which the optic nerve is damaged leading to loss of visual field.",
    img: "https://prasad-eye-hospital-public.s3.ap-south-1.amazonaws.com/images/services/glaucoma.png",
    imgAlt: "glaucoma",
  },
  {
    title: "Diabetic Retinopathy",
    summary:
      "Diabetic retinopathy is a complication of diabetes and causes damage to the retina (Microangiopathy).",
    img: "https://prasad-eye-hospital-public.s3.ap-south-1.amazonaws.com/images/services/diabeticretinopathy.png",
    imgAlt: "diabeticretinopathy",
  },
  {
    title: "Retinal Detachment",
    summary:
      "Retinal detachment describes an emergency situation in which a thin layer of tissue at the back of the eye pulls away from its normal position.",
    img: "https://prasad-eye-hospital-public.s3.ap-south-1.amazonaws.com/images/services/retina.png",
    imgAlt: "retina",
  },
  {
    title: "Cornea",
    summary:
      "Cornea is the clear front surface of the eye. It lies directly in front of the iris and pupil, and it allows light to enter the eye.",
    img: "https://prasad-eye-hospital-public.s3.ap-south-1.amazonaws.com/images/services/cornea.png",
    imgAlt: "cornea",
  },
  {
    title: "Oculoplastic Surgery",
    summary:
      "Oculoplasty, also known as ophthalmic plastic surgery, is surgery with relation to the eye and its surrounding structures.",
    img: "https://prasad-eye-hospital-public.s3.ap-south-1.amazonaws.com/images/services/qlasik.png",
    imgAlt: "qlasik",
  },
  {
    title: "Neuro Ophthalmology",
    summary:
      "A Neuro Ophthalmologist can diagnose and treat neurological and systemic diseases that affect your sight and the movement of eyes",
    img: "https://prasad-eye-hospital-public.s3.ap-south-1.amazonaws.com/images/services/amblyopia.png",
    imgAlt: "amblyopia",
  },
];
export default function Services({ setTab }) {
  return (
    <section
      className="ttm-row services-section bg-img1 clearfix"
      style={{ paddingBottom: "20px", paddingTop: "20px" }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-title title-style-center_text">
              <div className="title-header">
                <h3>what we offer</h3>
                <h2 className="title">Comprehensive Eye Care Services</h2>
              </div>
              <div className="heading-seperator">
                <span></span>
              </div>
              <div className="title-desc">
                <p>
                  Our facilities are equipped with state-of-the-art ophthalmic
                  technology to provide the most effective treatment.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="row row-equal-height">
          {services.map((service) => (
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="featured-icon-box icon-align-top-content style1">
                <div className="featured-icon">
                  <div
                    className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-size-lg"
                    style={{ backgroundColor: "#12b48b" }}
                  >
                    <img
                      className="img-fluid ttm-btn-color-skincolor"
                      src={service.img}
                      alt={service.imgAlt}
                    />
                  </div>
                </div>
                <div className="featured-content">
                  <div className="featured-title">
                    <h3>{service.title.toUpperCase()}</h3>
                  </div>
                  <div className="featured-desc">
                    <p>{service.summary}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="text-center margin_top35 res-991-margin_top20 margin_bottom70 res-1199-margin_bottom0">
              <p>
                <span className="font-weight-normal">
                  Don’t Hesitate, Contact us for Better Help and Services.{" "}
                </span>
                <br />
                <Link
                  to="/appointment"
                  className="ttm-btn ttm-btn-size-md ttm-btn-shape-round ttm-btn-style-border ttm-btn-color-dark margin_top15"
                  onClick={() => setTab("appointment")}
                >
                  Book Appointment
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
